import { useCallback, useRef, useState } from "react";
import { SESSION_DETAILS_ENDPOINT } from "../constants";
import { buildRestParams, normaliseDocs } from "../helpers";
import { modelsApi } from "../../../../../../API/axiosInstance"; // 🔥 interceptor-enabled axios

/**
 * Encapsulates all REST-based session fetching logic.
 */
export default function useSessionFetch({ objective, applyDocs }) {
  const sessionsMapRef = useRef(new Map());
  const [crawlIsLoading, setCrawlIsLoading] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const fetchSessionCards = useCallback(
    async (
      page = 1,
      platform = "",
      status = null,
      timeRange = "30d",
      keyword = "",
      sourceType = null,
    ) => {
      setCrawlIsLoading(true);

      try {
        const qs = buildRestParams({
          page,
          platform,
          status,
          objective,
          dateTimeRange: timeRange,
          keyword,
          sourceType,
        });

        // 🔥 Using interceptor-enabled axios
        const response = await modelsApi.get(`${SESSION_DETAILS_ENDPOINT}?${qs}`);

        const resData = response.data;
        const docs = normaliseDocs(resData.data);

        // O(1) lookup map
        sessionsMapRef.current = new Map(docs.map((d) => [d._id, d]));

        applyDocs(docs, platform);

        setHasMore(resData.page < resData.total_pages);
        setTotalPageCount(resData.total_pages || 1);

        return docs;
      } catch (err) {
        console.error("fetchSessionCards error:", err);
        return [];
      } finally {
        setCrawlIsLoading(false);
      }
    },
    [objective, applyDocs]
  );

  return {
    sessionsMapRef,
    crawlIsLoading,
    totalPageCount,
    hasMore,
    fetchSessionCards,
  };
}
